import React from 'react'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Dialog from 'components_new/atoms/Dialog'
import DialogActions from 'components_new/atoms/Dialog/DialogActions'
import DialogContent from 'components_new/atoms/Dialog/DialogContent'
import DialogTitle from 'components_new/atoms/Dialog/DialogTitle'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'

interface DiscardDialogProps {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

/**
 * Confirmation shown when the user leaves edit mode with unsaved changes.
 * Cancelling keeps the user editing; confirming discards the edits.
 */
const DiscardDialog = (props: DiscardDialogProps) => {
  const { open, onCancel, onConfirm } = props

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs">
      <Box sx={{ p: 3 }}>
        <Box sx={{ alignItems: 'center', display: 'flex', gap: 1.5 }}>
          <Box
            sx={{
              alignItems: 'center',
              backgroundColor: 'warning.transparent',
              borderRadius: '50%',
              color: 'warning.main',
              display: 'flex',
              flex: 'none',
              height: 40,
              justifyContent: 'center',
              width: 40
            }}
          >
            <Icon name="WarningAmberOutlined" />
          </Box>
          <DialogTitle sx={{ p: 0 }}>Osparade ändringar</DialogTitle>
        </Box>
        <DialogContent sx={{ px: 0, py: 2 }}>
          <Text color="text.secondary">
            Du har osparade ändringar och förlorar dem om du fortsätter.
          </Text>
        </DialogContent>
        <DialogActions sx={{ p: 0 }}>
          <Button onClick={onCancel} variant="outlined">
            Avbryt
          </Button>
          <Button onClick={onConfirm} variant="contained">
            Fortsätt
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DiscardDialog
